import PropTypes from "prop-types";
import React from "react";
import InsuranceContentNoInsurance from "app/pages/Booking/Payment/Insurances/InsuranceContentNoInsurance";
import InsuranceContentWithInsurance from "app/pages/Booking/Payment/Insurances/InsuranceContentWithInsurance";

const InsuranceContent = ({ insurance, field, note, isFirstItem }) => {
	return (
		<div className="insurances__body">
			{insurance.price ? (
				<InsuranceContentWithInsurance
					note={note}
					isFirstItem={isFirstItem}
					insurance={insurance}
				/>
			) : (
				field.value === insurance.code && <InsuranceContentNoInsurance />
			)}
		</div>
	);
};

InsuranceContent.propTypes = {
	field: PropTypes.object.isRequired,
	insurance: PropTypes.object.isRequired,
	isFirstItem: PropTypes.bool.isRequired,
	note: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default InsuranceContent;
